import {SET_COUNT, SET_ORDER, SET_ORDER_BY, SET_PAGE, SET_ROWS_PER_PAGE} from "./actions/ActionTypes";

export const TABLE_INITIAL_STATE = {}

export const TableReducer = (state = TABLE_INITIAL_STATE, action) => {
	/*console.log(action);*/
	switch (action.type) {
		case SET_PAGE:
			return {
				...state,
				page: action.payload,
			}
		case SET_ROWS_PER_PAGE:
			return {
				...state,
				rowsPerPage: action.payload,
			}
		case SET_ORDER:
			return {
				...state,
				order: action.payload,
			}
		case SET_ORDER_BY:
			return {
				...state,
				orderBy: action.payload,
			}
		case SET_COUNT:
			return {
				...state,
				count: action.payload
			}
		
		default:
			return state;
	}
}
